import React from "react";
import parse from "html-react-parser";

//styles
import "./format-10.style.scss";
import { useMediaQuery } from "react-responsive";

//React Bootstrap
import { Container, Row, Col } from "react-bootstrap";

const checkValue = (val) => {
  return val && val !== "" ? true : false;
}

const Format10 = (props) => {
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-width: 992px)",
  });
  
  const checkImageMobile = () => {
    if(isTabletOrMobileDevice && checkValue(props.item.image_mobile)){
      return props.item.image_mobile;
    }
    else{
      return props.item.image;
    }
  }

  return (
    <Container bsPrefix="container-xl format-10" key={props.keyUniq}>
      <div className="content">
        {/* ICON */}
        {checkValue(props.item.icon) && (
          <img src={props.item.icon} className="img-icon" alt="" />
        )}

        {/* TITLE */}
        <Row className="title">
          <h1>{props.item.name}</h1>
        </Row>

        {/* SUBTITLE */}
        {checkValue(props.item.subname) && (
          <Row className="subtitle">
            <span>
            {parse(props.item.subname)}
            </span>
          </Row>
        )}

        {/* DESCRIPTION */}
        {checkValue(props.item.desc) && (
          <Row className="desc">{parse(props.item.desc)}</Row>
        )}
      </div>

      {/* IMAGE */}
      {checkValue(props.item.image) && (
         <img src={checkImageMobile()} className="img-fluid" alt="" />
      )}
    </Container>
  );
};

export default Format10;
